import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, concatMap, exhaustMap, map, of, tap } from "rxjs";
import { NotifyService } from 'src/app/shared/services/notify.service';
import { PaymentMachineService } from "src/app/shared/services/payment-machine.service";
import { paymentMachineActions } from "./payment-machine.actions";

@Injectable()

export class paymentMachineEffects {

    constructor(
        private service: PaymentMachineService,
        private notify: NotifyService,
        private action$: Actions
    ) { }

    loadPaymentMachine$ = createEffect(() =>
        this.action$.pipe(
            ofType(paymentMachineActions.loadPaymentMachine),
            exhaustMap(() =>
                this.service
                    .getAll()
                    .pipe(
                        map((res) => paymentMachineActions.loadPaymentMachineSuccess({ lista: res })),
                        catchError((error) => {
                            return of(error.error['hydra:description'])
                        })
                    )

            )
        )
    )

    savePaymentMachine$ = createEffect(() =>
        this.action$.pipe(
            ofType(paymentMachineActions.savePaymentMachine),
            concatMap(
                ({ machine }) =>
                    this.service.post(machine).pipe(
                        tap(() => this.notify.saveSuccess()),
                        map(() => paymentMachineActions.loadPaymentMachine()),
                        catchError(
                            (error) => {
                                return of(error.error['hydra:description'])
                            }
                        )
                    )
            )
        )

    )

    deletePaymentMachine$ = createEffect(() =>
        this.action$.pipe(
            ofType(paymentMachineActions.deletePaymentMachine),
            concatMap(
                ({ id }) =>
                    this.service.delete(id).pipe(
                        tap(() => this.notify.deleteSuccess()),
                        map((res) => paymentMachineActions.loadPaymentMachine()),

                        catchError((error) => {
                            return of(error.error['hydra:description']);
                        }

                        )
                    )
            )
        )
    )

    editPaymentMachine$ = createEffect(() =>
        this.action$.pipe(
            ofType(paymentMachineActions.editPaymentMachine),
            concatMap(
                ({ machine, id }) =>
                    this.service.edit(machine,id).pipe(
                        tap(() => this.notify.editSuccess()),
                        map((res) => paymentMachineActions.loadPaymentMachine()),

                        catchError((error) => {
                            return of(error.error['hydra:description']);
                        }

                        )
                    )
            )
        )
    )


}